module.exports = __webpack_public_path__ + "PrintingReturnLabelUnbranded.d6ee118415b87e3452b021ddd5cdbae4.png";